
  <div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input  class="w-full border p-2 rounded-md outline-none"
          placeholder="Search lead" matInput (keyup)="applyFilter($event)" />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="onStatusChange($event)">
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>

       
      </div>

      <div class="w-60">
        <app-primary-button routerLink="/home/create-lead" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add Lead</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>

  <!-- Table Section -->
  <div class="bg-white rounded-2xl shadow-md p-4">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 w-full text-sm">
      <!-- S.No -->
      <ng-container matColumnDef="sno">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ i + 1  }}
        </td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let user">{{ user.name }}</td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let user">{{ user.status }}</td>
      </ng-container>

      <!-- Account -->
      <ng-container matColumnDef="accountName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
        <td mat-cell *matCellDef="let user">{{ user.accountName }}</td>
      </ng-container>

      <!-- Office Number -->
      <ng-container matColumnDef="officeNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Office Number</th>
        <td mat-cell *matCellDef="let user">{{ user.officeNumber }}</td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>

      <!-- Header & Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 text-gray-700 font-semibold"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
    </table>
 <app-empty-data *ngIf="dataSource.data.length < 1" class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
    <!-- Paginator -->
    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      class="mt-4"
    ></mat-paginator>
  </div>
</div>
